import { useEffect, useState } from "react";
import { addressQuery, addressSearchBase, photonHits, type AddressHit } from "../lib/adresssuche";
import { currentLang } from "../lib/sprache";

const BASE = addressSearchBase(import.meta.env.VITE_ADDRESS_SEARCH_URL as string | undefined);

/** Ist die Adresssuche eingeschaltet (VITE_ADDRESS_SEARCH_URL)? Ohne sie zeigt keine Seite Vorschläge. */
export const addressSearchOn = BASE !== null;

/**
 * Vorschläge unter dem Straßenfeld (PARITAET-14): nur mit eingeschaltetem Dienst, ab vier Zeichen, verzögert; ein Klick
 * übernimmt Straße, PLZ, Ort und Land. Ohne Dienst oder bei einem Fehler: nichts (das Feld bleibt ein Textfeld).
 */
/** fertig: Text, den das Feld nach der Wahl enthält (Standard: Straße), damit danach keine Vorschläge mehr erscheinen */
export function AdressVorschlag({ text, onPick, lang = currentLang(), fertig }: { text: string; onPick: (a: AddressHit) => void; lang?: "de" | "en"; fertig?: (a: AddressHit) => string }) {
  const [hits, setHits] = useState<AddressHit[]>([]);
  const [picked, setPicked] = useState<string | null>(null);
  useEffect(() => {
    const url = BASE ? addressQuery(BASE, text, lang) : null;
    if (!url || text === picked) { setHits([]); return; }
    const ctrl = new AbortController();
    const timer = setTimeout(() => {
      fetch(url, { signal: ctrl.signal, credentials: "omit", referrerPolicy: "no-referrer" })
        .then((r) => (r.ok ? r.json() : null)).then((j) => setHits(photonHits(j))).catch(() => setHits([]));
    }, 350);
    return () => { clearTimeout(timer); ctrl.abort(); };
  }, [text, lang, picked]);
  if (!hits.length) return null;
  return (
    <div className="stack tk-gap-sm" role="group" aria-label={lang === "en" ? "Address suggestions" : "Adressvorschläge"}>
      <small>{lang === "en" ? "Suggestions:" : "Vorschläge:"}</small>
      <div className="row">
        {hits.map((h) => (
          <button key={h.label} type="button" className="quiet" onClick={() => { setPicked(fertig ? fertig(h) : h.street); setHits([]); onPick(h); }}>{h.label}</button>
        ))}
      </div>
    </div>
  );
}
